// Royal Gifts Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  const toggle = document.querySelector('.mobile-nav-toggle');
  const nav = document.querySelector('.site-nav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      const isOpen = nav.style.display === 'flex';
      nav.style.display = isOpen ? 'none' : 'flex';
      nav.style.flexDirection = 'column';
      nav.style.position = 'absolute';
      nav.style.top = '100%';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = '#111';
      nav.style.padding = '16px';
      nav.style.zIndex = '999';
      toggle.innerHTML = isOpen ? '&#x2630;' : '&#x2715;';
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Product image thumbnail switcher
  document.querySelectorAll('.product-page__thumbnails img').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.product-page__main-img');
      if (mainImg) mainImg.src = this.src.replace('_120x', '_700x');
    });
  });

  // Cart AJAX add (optional enhancement)
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function (e) {
      // Allow default form submit for Shopify compatibility
      // Can be enhanced with fetch() for AJAX cart
    });
  });

});
